import pipe from 'transmute/pipe';
import { HTMLMediaElement } from '../components/MediaElements';
import { withIntegrationsRecordingUrlRefresh } from './_internal-media-element-hocs/withIntegrationsRecordingUrlRefresh';
import { withInternalAuthedRecordingUrl } from './_internal-media-element-hocs/withInternalAuthedRecordingUrl';
import { memo, useContext } from 'react';
import { MediaElementContext } from '../context/MediaElementContext';
import { withZoomAudioDownload } from './_internal-media-element-hocs/withZoomAudioDownload';
import { MediaPlaybackControlsContext } from '../context/MediaPlaybackControlsContext';
import { withRecordingUrlReset } from './_internal-media-element-hocs/withRecordingUrlReset';
import { AUDIO } from '../../types/CallMediaTypes';
import { jsx as _jsx } from "react/jsx-runtime";
const FEATURES = [
// These need to be in a specific order here, confirm when adding new features
// be aware that this list is in reverse order of execution.
['RECORDING_URL_RESET', withRecordingUrlReset], ['INTERNAL_RECORDING_URL_PARSER', withInternalAuthedRecordingUrl], ['INTEGRATIONS_RECORDING_REFRESH', withIntegrationsRecordingUrlRefresh], ['ZOOM_AUDIO_DOWNLOAD', withZoomAudioDownload]];
export const composeMediaElement = (features = []) => {
  const ComposedHTMLMediaElement = pipe(...FEATURES.filter(([key]) => features.includes(key)).map(([__, fn]) => fn))(HTMLMediaElement);
  return /*#__PURE__*/memo(({
    videoPlayerOptions
  }) => {
    const {
      mediaRef,
      recordingUrl,
      source,
      isInvalidMediaUrl,
      mediaType
    } = useContext(MediaElementContext);
    const {
      status
    } = useContext(MediaPlaybackControlsContext);
    if (isInvalidMediaUrl) return null;
    return /*#__PURE__*/_jsx(ComposedHTMLMediaElement, {
      mediaRef: mediaRef,
      mediaType: mediaType || AUDIO,
      recordingUrl: recordingUrl,
      source: source,
      status: status,
      videoPlayerOptions: videoPlayerOptions
    });
  });
};